<template>
  <fieldset :class="`_grid ${isGrouped ? 'fieldset__group fieldset__group' : 'fieldset__nogroup'}${isGrouped && isHidden ? '--hidden' : ''}${isGrouped && !isHidden ? '--visible' : ''}`">
    <legend v-if="element.legend && !isGrouped" class="_text:md _col(12)" >{{element.legend}} {{element.required ? '*' : ''}}</legend>
    <SimpleElement
      v-else-if="isGrouped"
      :element="element.legend"
      :elementValues="elementValues"
      :readonly="isReadonly"
    />

    <div v-if="element.helperText" class="_text:xs _col(12)">
      <p v-html="element.helperText" />
    </div>
    <slot></slot>
  </fieldset>
</template>

<script>

import { eventBus } from '@/eventBus';
import { evaluateCondition } from '@/utils';

export default {
  name: 'FieldsetElement',
  components: { SimpleElement: () => import('./SimpleElement.vue') },
  props: {
    element: {
      type: Object,
      required: true
    },
    elementValues: {
      type: Object,
      required: true
    },
    isGrouped: {
      type: Boolean,
      default: false
    },
    isReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDisabled () {
      return evaluateCondition(this.element.disabledWhen, this.elementValues);
    },
    isHidden () {
      return evaluateCondition(this.element.hiddenWhen, this.elementValues);
    }
  },
  watch: {
    isDisabled () {
      this.disabledHandler();
    },
    isHidden () {
      this.hiddenHandler();
    }
  },
  methods: {
    disabledHandler () {
      if (this.element.id) {
        eventBus.$emit('fieldsetDisabled', { fieldsetId: this.element.id, isDisabled: this.isDisabled });
      }
    },
    hiddenHandler () {
      if (this.element.id) {
        eventBus.$emit('fieldsetHidden', { fieldsetId: this.element.id, isHidden: this.isHidden });
      }
    }
  },
  mounted () {
    this.disabledHandler();
    this.hiddenHandler();
  }
};
</script>

<style lang="less">
  @import '../../utils.less';

  .fieldset__group {
    padding: calc(var(--gw) * 1.25);
    border-radius: calc(var(--radius) * 1.25);
    transition: box-shadow 0.15s ease-in-out;

    &--hidden {
      border: 1px solid var(--grey-400);
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }

    &--visible {
      ._shadow\(2\);
    }
  }
  .fieldset__nogroup {
    ds-select{
      .value-container {
        max-width: 15rem !important;
      }
    }
    @media screen and (max-width: 80rem) {
      ds-select{
      .value-container {
        max-width: unset !important;
      }
    }
  }
}

</style>
